import { IAssetCategoryResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
    DataSourceSort,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

export const assetCategoryDefaultSort: DataSourceSort[] = [{ field: 'Name', dir: 'asc' }];

export type AssetCategoriesFilter = Readonly<{
    nameSearch?: string;
    assetTypeId?: number;
}>;

export type UseAssetCategoryDataSourceOptions = BaseDataSourceOptions<
    IAssetCategoryResponse,
    AssetCategoriesFilter
>;

const getAssetCategories: DataSourceQuery<
    IAssetCategoryResponse,
    AssetCategoriesFilter
> = async ({ filter: { nameSearch, assetTypeId }, sort, page, pageLimit }) => {
    const filter = Filter.and(
        nameSearch ? Filter.contains('Name', nameSearch) : undefined,
        assetTypeId ? Filter.eq('TypeId', assetTypeId) : undefined,
    );
    const orderBy = buildOrderBy(sort);

    return toDataSourceResult(
        sdClient.getAssetClassificationCategories({
            filter,
            page,
            pageLimit,
            orderBy,
            nameSearch,
        }),
    );
};

export type AssetCategoryPagedDataSource = PagedDataSource<
    IAssetCategoryResponse,
    AssetCategoriesFilter
>;

export function usePagedAssetCategoryDataSource({
    defaultSort = assetCategoryDefaultSort,
    ...options
}: UseAssetCategoryDataSourceOptions): AssetCategoryPagedDataSource {
    return usePagedDataSource({
        defaultSort,
        ...options,
        query: getAssetCategories,
    });
}

export type AssetCategoryInfiniteDataSource = InfiniteDataSource<
    IAssetCategoryResponse,
    AssetCategoriesFilter
>;

export function useInfiniteAssetCategoryDataSource({
    defaultSort = assetCategoryDefaultSort,
    ...options
}: UseAssetCategoryDataSourceOptions): AssetCategoryInfiniteDataSource {
    return useInfiniteDataSource({
        defaultSort,
        ...options,
        query: getAssetCategories,
    });
}
